import { createAction } from '@'
import { $tableData } from '../stores'

export default createAction('table:SetTableData', (name, data) => {
    $tableData.subStore(name).setState(() => data)
})
